import { render, staticRenderFns } from "./BoxWithImg.vue?vue&type=template&id=56a2dbc3&scoped=true&"
import script from "./BoxWithImg.vue?vue&type=script&lang=js&"
export * from "./BoxWithImg.vue?vue&type=script&lang=js&"
import style0 from "./BoxWithImg.vue?vue&type=style&index=0&id=56a2dbc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2dbc3",
  null
  
)

export default component.exports